import { useLocation } from "wouter";
import { Monitor, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

interface DesktopOnlyNoticeProps {
  title: string;
  description?: string;
}

export function DesktopOnlyNotice({ title, description }: DesktopOnlyNoticeProps) {
  const [, navigate] = useLocation();
  return (
    <div className="px-4 py-8 max-w-md mx-auto">
      <Card>
        <CardContent className="p-6 text-center">
          <div className="w-16 h-16 bg-bauwerk-teal/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <Monitor className="w-8 h-8 text-bauwerk-teal" />
          </div>
          <h2 className="text-xl font-semibold text-bauwerk-teal mb-2">
            {title}
          </h2>
          <p className="text-gray-600 text-sm mb-6">
            {description ??
              "Diese Ansicht ist für den Desktop optimiert – bitte am Computer öffnen."}
          </p>
          <Button
            type="button"
            onClick={() => navigate("/dashboard")}
            className="w-full bg-bauwerk-orange hover:bg-bauwerk-light-orange py-3 h-auto"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Zurück zur Projektübersicht
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
